import React, { Component } from "react";
import PropTypes from "prop-types";
import { FormControl } from "react-bootstrap";

class Search extends Component {
  static propTypes = {
    searchStr: PropTypes.string,
    handleSearch: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      searchStr: this.props.searchStr,
      typingTimer: null,
      prevPropsSearchStr: this.props.searchStr
    };
  }

  UNSAFE_componentWillReceiveProps() {
    if (this.state.searchStr != this.props.searchStr) {
      this.setState({ searchStr: this.props.searchStr });
    }
  }

  handleKeyUp(e) {
    let searchStr = e.target.value;
    clearTimeout(this.state.typingTimer);
    this.setState({ searchStr: searchStr, typingTimer: setTimeout(this.doneTyping.bind(this), 500) });
  }

  handleKeyDown() {
    clearTimeout(this.state.typingTimer);
  }

  doneTyping(e) {
    let searchStr = this.state.searchStr;
    this.props.handleSearch(searchStr);
  }

  render() {
    return (
      <FormControl
        componentClass="input"
        type="text"
        className="search_field"
        value={this.state.searchStr}
        placeholder="Search"
        // onKeyDown={this.handleKeyDown.bind(this)}
        // onKeyUp={this.handleKeyUp.bind(this)}
        groupClassName="m-b-5"
        onChange={this.handleKeyUp.bind(this)}
      />
    );
  }
}

export default Search;
